export const LOGIN_LINK = '/auth/login?next_action=/cart';
export const SIGNUP_LINK = '/signup';
